import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './rating-icon.scss';

const RATING_ICON_CONFIG = {
  1: { icon: 'minus', textColor: 'text-orange-10', bgColor: 'bg-orange-90', size: 'size-20', className: 'fw-bold' },
  2: { icon: 'icon-checkmark', textColor: 'text-blue-40', bgColor: 'bg-blue-90', size: 'size-8' },
  3: { icon: 'icon-checkmark', textColor: 'text-blue-40', bgColor: 'bg-blue-90', size: 'size-8' },
  4: { icon: 'icon-checkmark', textColor: 'text-gem-5', bgColor: 'bg-gem-2', size: 'size-8' },
  5: { icon: 'icon-checkmark', textColor: 'text-gem-5', bgColor: 'bg-gem-2', size: 'size-8' },
};

export function RatingIcon({ rating }) {
  const config = RATING_ICON_CONFIG[rating];

  const { className, textColor, bgColor, size, icon } = config;

  return (
    <span
      className={classNames(
        'key-insights-list-item-icon text-center rounded-circle flex-shrink-0',
        icon,
        className,
        textColor,
        bgColor,
        size
      )}
      aria-hidden
    />
  );
}

RatingIcon.propTypes = {
  rating: PropTypes.oneOf([1, 2, 3, 4, 5]).isRequired,
};
